import { render, staticRenderFns } from "./CreateUpdateTaxDataSidebar.vue?vue&type=template&id=1a708a76&scoped=true"
import script from "./CreateUpdateTaxDataSidebar.vue?vue&type=script&lang=js"
export * from "./CreateUpdateTaxDataSidebar.vue?vue&type=script&lang=js"
import style0 from "./CreateUpdateTaxDataSidebar.vue?vue&type=style&index=0&id=1a708a76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a708a76",
  null
  
)

export default component.exports